module.exports = [{"code":1,"name":"在职"},{"code":2,"name":"离职"},{"code":99,"name":"其他"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/personStatus.json
// module id = zloV
// module chunks = 11